/* eslint-disable */
/* tslint:disable */
import * as React from 'react'
export interface SubnetProps extends React.SVGAttributes<SVGElement> {
  size?: string | number
}
const Subnet: React.FC<SubnetProps> = ({ size, ...props }) => (
  <svg version='1.0' width={size || '20'} height={size || '20'} viewBox='0 0 512 512' {...props}>
    <g
      transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
      fill='#000000'
      stroke='none'
    >
      <path
        d='M2465 4899 c-260 -40 -472 -238 -529 -496 -32 -144 -14 -282 55 -423
56 -115 169 -228 282 -284 l77 -38 -2 -441 -3 -442 -957 -3 -958 -2 0 -654 0
-654 -78 -38 c-112 -56 -225 -169 -281 -284 -158 -323 -36 -694 282 -856 95
-49 175 -67 287 -67 250 0 465 135 574 358 88 179 86 379 -5 565 -56 115 -169
228 -282 284 l-77 38 2 441 3 442 745 0 745 0 3 -442 2 -441 -77 -38 c-113
-56 -226 -169 -282 -284 -158 -323 -36 -694 282 -856 95 -49 175 -67 287 -67
250 0 465 135 574 358 88 179 86 379 -5 565 -56 115 -169 228 -282 284 l-77
38 2 441 3 442 745 0 745 0 3 -442 2 -441 -77 -38 c-113 -56 -226 -169 -282
-284 -158 -323 -36 -694 282 -856 95 -49 175 -67 287 -67 250 0 465 135 574
358 88 179 86 379 -5 565 -56 115 -169 228 -281 284 l-78 38 0 654 0 654 -957
2 -958 3 -3 442 -2 441 77 38 c113 56 226 169 282 284 69 141 86 268 55 418
-66 327 -389 552 -719 501z'
      />
    </g>
  </svg>
)
Subnet.displayName = 'Subnet'
export default Subnet
/* tslint:enable */
/* eslint-enable */
